<template>
    <Panel class="detail-panel">
        <template v-slot:header>
            <Button
                v-if="this.settings.features.listDisplay && !this.showSingleItem"
                size="large"
                @click="this.$emit('hideDetailPanel')"
                aria-label="Ga terug naar lijstweergave"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#000000"
                >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
                </svg>
            </Button>
            <Button size="large" @click="this.$emit('hideDetailAndListPanel')" aria-label="Sluit detailweergave" class="hide-button">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#000000"
                >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                </svg>
            </Button>
        </template>

        <img v-if="feature['plaatje']" :src="feature.plaatje" class="featured-image" />
        <img v-if="feature['afbeelding']" :src="feature.afbeelding" class="featured-image" />
        <img v-if="feature['image']" :src="feature.image" class="featured-image" />
        <img v-if="feature['foto']" :src="feature.foto" class="featured-image" />

        <div class="details">
            <h3>{{ feature['titel'] || feature['naam'] || feature['title'] || feature['Vervoersmiddel'] }}</h3>
            <div v-if="feature['Hub']" class="type">{{ feature['Hub'] }}<img src="/images/marker-hub.svg" aria-hidden="true" data-v-3ec048fa=""></div>
            <div v-if="feature['adres']" class="address">{{ feature['adres'] }}</div>
            <div v-if="feature['Adresindicatie']" class="address">{{ feature['Adresindicatie'] }}</div>

            <p v-if="feature['korte_beschrijving']">
                <markdown :source="feature['korte_beschrijving']" :inline="false" />
            </p>

            <p v-if="feature['beschrijving']">
                <markdown :source="feature['beschrijving']" :inline="false" />
            </p>

            <p v-if="feature['omschrijving']">
                <markdown :source="feature['omschrijving']" :inline="false" />
            </p>

            <p v-if="feature['description']">
                <markdown :source="feature['description']" :inline="false" />
            </p>

            <p v-if="feature['wat']">
                <markdown :source="feature['wat']" :inline="false" />
            </p>
        </div>

        <div class="links">
            <a v-if="feature['verhaal']" :href="feature['verhaal']" target="_parent">
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="public_black_24dp"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M4,12 C4,11.39 4.08,10.79 4.21,10.22 L8.99,15 L8.99,16 C8.99,17.1 9.89,18 10.99,18 L10.99,19.93 C7.06,19.43 4,16.07 4,12 Z M17.89,17.4 C17.63,16.59 16.89,16 15.99,16 L14.99,16 L14.99,13 C14.99,12.45 14.54,12 13.99,12 L7.99,12 L7.99,10 L9.99,10 C10.54,10 10.99,9.55 10.99,9 L10.99,7 L12.99,7 C14.09,7 14.99,6.1 14.99,5 L14.99,4.59 C17.92,5.77 20,8.65 20,12 C20,14.08 19.19,15.98 17.89,17.4 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                Lees het verhaal op de site
                <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="open_in_new_black_18dp-(1)"
                            transform="translate(-2.000000, -2.000000)"
                            fill="#000000"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M14.25,14.25 L3.75,14.25 L3.75,3.75 L9,3.75 L9,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,9 L14.25,9 L14.25,14.25 Z M10.5,2.25 L10.5,3.75 L13.1925,3.75 L5.82,11.1225 L6.8775,12.18 L14.25,4.8075 L14.25,7.5 L15.75,7.5 L15.75,2.25 L10.5,2.25 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </a>
            <a v-if="feature['link']" :href="feature['link']" target="_parent">
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="public_black_24dp"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M4,12 C4,11.39 4.08,10.79 4.21,10.22 L8.99,15 L8.99,16 C8.99,17.1 9.89,18 10.99,18 L10.99,19.93 C7.06,19.43 4,16.07 4,12 Z M17.89,17.4 C17.63,16.59 16.89,16 15.99,16 L14.99,16 L14.99,13 C14.99,12.45 14.54,12 13.99,12 L7.99,12 L7.99,10 L9.99,10 C10.54,10 10.99,9.55 10.99,9 L10.99,7 L12.99,7 C14.09,7 14.99,6.1 14.99,5 L14.99,4.59 C17.92,5.77 20,8.65 20,12 C20,14.08 19.19,15.98 17.89,17.4 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                {{this.settings.detailLinkText || 'Ga naar het onderzoeksrapport'}}
                <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="open_in_new_black_18dp-(1)"
                            transform="translate(-2.000000, -2.000000)"
                            fill="#000000"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M14.25,14.25 L3.75,14.25 L3.75,3.75 L9,3.75 L9,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,9 L14.25,9 L14.25,14.25 Z M10.5,2.25 L10.5,3.75 L13.1925,3.75 L5.82,11.1225 L6.8775,12.18 L14.25,4.8075 L14.25,7.5 L15.75,7.5 L15.75,2.25 L10.5,2.25 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </a>
            <a v-if="feature['Website aanbieder']" :href="feature['Website aanbieder']" target="_parent">
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="public_black_24dp"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M4,12 C4,11.39 4.08,10.79 4.21,10.22 L8.99,15 L8.99,16 C8.99,17.1 9.89,18 10.99,18 L10.99,19.93 C7.06,19.43 4,16.07 4,12 Z M17.89,17.4 C17.63,16.59 16.89,16 15.99,16 L14.99,16 L14.99,13 C14.99,12.45 14.54,12 13.99,12 L7.99,12 L7.99,10 L9.99,10 C10.54,10 10.99,9.55 10.99,9 L10.99,7 L12.99,7 C14.09,7 14.99,6.1 14.99,5 L14.99,4.59 C17.92,5.77 20,8.65 20,12 C20,14.08 19.19,15.98 17.89,17.4 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                Website van aanbieder
                <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="open_in_new_black_18dp-(1)"
                            transform="translate(-2.000000, -2.000000)"
                            fill="#000000"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M14.25,14.25 L3.75,14.25 L3.75,3.75 L9,3.75 L9,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,9 L14.25,9 L14.25,14.25 Z M10.5,2.25 L10.5,3.75 L13.1925,3.75 L5.82,11.1225 L6.8775,12.18 L14.25,4.8075 L14.25,7.5 L15.75,7.5 L15.75,2.25 L10.5,2.25 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </a>
            <a v-if="feature['website']" :href="feature['website']" target="_parent">
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="public_black_24dp"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M4,12 C4,11.39 4.08,10.79 4.21,10.22 L8.99,15 L8.99,16 C8.99,17.1 9.89,18 10.99,18 L10.99,19.93 C7.06,19.43 4,16.07 4,12 Z M17.89,17.4 C17.63,16.59 16.89,16 15.99,16 L14.99,16 L14.99,13 C14.99,12.45 14.54,12 13.99,12 L7.99,12 L7.99,10 L9.99,10 C10.54,10 10.99,9.55 10.99,9 L10.99,7 L12.99,7 C14.09,7 14.99,6.1 14.99,5 L14.99,4.59 C17.92,5.77 20,8.65 20,12 C20,14.08 19.19,15.98 17.89,17.4 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                Website
                <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="open_in_new_black_18dp-(1)"
                            transform="translate(-2.000000, -2.000000)"
                            fill="#000000"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M14.25,14.25 L3.75,14.25 L3.75,3.75 L9,3.75 L9,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,9 L14.25,9 L14.25,14.25 Z M10.5,2.25 L10.5,3.75 L13.1925,3.75 L5.82,11.1225 L6.8775,12.18 L14.25,4.8075 L14.25,7.5 L15.75,7.5 L15.75,2.25 L10.5,2.25 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </a>
            <a v-if="feature['url']" :href="feature['url']" target="_parent">
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="public_black_24dp"
                            transform="translate(-2.000000, -2.000000)"
                            fill="currentColor"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M4,12 C4,11.39 4.08,10.79 4.21,10.22 L8.99,15 L8.99,16 C8.99,17.1 9.89,18 10.99,18 L10.99,19.93 C7.06,19.43 4,16.07 4,12 Z M17.89,17.4 C17.63,16.59 16.89,16 15.99,16 L14.99,16 L14.99,13 C14.99,12.45 14.54,12 13.99,12 L7.99,12 L7.99,10 L9.99,10 C10.54,10 10.99,9.55 10.99,9 L10.99,7 L12.99,7 C14.09,7 14.99,6.1 14.99,5 L14.99,4.59 C17.92,5.77 20,8.65 20,12 C20,14.08 19.19,15.98 17.89,17.4 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
                Meer informatie over het project
                <svg
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                            id="open_in_new_black_18dp-(1)"
                            transform="translate(-2.000000, -2.000000)"
                            fill="#000000"
                            fill-rule="nonzero"
                        >
                            <path
                                d="M14.25,14.25 L3.75,14.25 L3.75,3.75 L9,3.75 L9,2.25 L3.75,2.25 C2.9175,2.25 2.25,2.925 2.25,3.75 L2.25,14.25 C2.25,15.075 2.9175,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,9 L14.25,9 L14.25,14.25 Z M10.5,2.25 L10.5,3.75 L13.1925,3.75 L5.82,11.1225 L6.8775,12.18 L14.25,4.8075 L14.25,7.5 L15.75,7.5 L15.75,2.25 L10.5,2.25 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            </a>
        </div>

        <div class="details">
            <dl>
                <div v-for="field in fields" v-bind:key="field">
                    <dt>{{ field.title }}</dt>
                    <dd v-if="feature[field.key] && typeof feature[field.key] === 'string'">
                        <markdown :source="feature[field.key]" />
                    </dd>
                    <dd v-if="feature[field.key] && typeof feature[field.key] === 'object'">
                        {{ feature[field.key].join(', ') }}
                    </dd>
                </div>
            </dl>
        </div>
    </Panel>
</template>

<script>
import Markdown from './Markdown'
import Panel from './Panel.vue'
import Button from './Button.vue'

export default {
    name: 'DetailPanel',
    components: {
        Panel,
        Button,
        Markdown,
    },
    props: {
        feature: Object,
        fields: Object,
        showSingleItem: Boolean,
    },
    methods: {
        closePanel() {
            this.$emit('close-panel')
        },
    },
    inject: ['settings'],
}
</script>

<style scoped>
.details {
    padding: var(--padding-screen);
}

.details ::v-deep(a) {
    color: var(--color-primary);
    text-decoration: none;
}

.details ::v-deep(a:hover),
.details ::v-deep(a:active) {
    text-decoration: underline;
}

.details ::v-deep(ul) {
    margin: 20px;
    list-style-type: disc;
}

h3 {
    margin: 0;
    font-size: var(--font-size-large);
}

p {
    margin: 16px 0 0;
}

dl {
    margin: 0;
}

dt {
    display: block;
    margin: 0 0 4px;
    font-weight: var(--font-weight-bold);
}

dd {
    margin: 0 0 16px;
}

a {
    color: var(--color-primary);
}

.featured-image {
    width: 100%;
    margin-top: calc(var(--padding-screen) * -1 + var(--width-button-large) * -1);
}

.type {
    display: flex;
    align-items: center;
    font-size: var(--font-size-small);
    color: var(--color-text-grey);
}

.type img {
    margin-left: 5px;
    width: 25px;
    height: 25px;
}

.address {
    margin-top: 2px;
    font-size: var(--font-size-small);
}

.hide-button {
    margin-left: auto;
}

.links > * {
    box-sizing: border-box;
    min-height: 40px;
    display: flex;
    align-items: center;
    border-top: 1px solid var(--color-grey-30);
    padding: 8px var(--padding-screen) 9px;
    text-decoration: none;
}

.links > a {
    color: var(--color-primary);
}

.links > *:last-child {
    border-bottom: 1px solid var(--color-grey-30);
}

.links a:hover,
.links a:active {
    text-decoration: underline;
}

.links svg {
    flex-shrink: 0;
}

.links svg:first-child {
    margin-right: 8px;
}

.links svg:last-child:not(:first-child) {
    padding-left: 8px;
    margin-left: auto;
}
</style>
